import loadable from "@loadable/component"

const Header = loadable(() => import("./Header/Header"))
const Calculator = loadable(() => import("./Calculator/Calculator"))
const TalkToExpert = loadable(() => import("./Header/TalkToExpert/TalkToExpert"))
const Image = loadable(() => import("./Common/Image/Image"))
const MaterialModal = loadable(() => import("./Common/MaterialModal/MaterialModal"))
const ExtraHeader = loadable(() => import("./ExtraHeader/ExtraHeader"))
const QuickGuide = loadable(() => import("./QuickGuide/QuickGuide"))
const HeroSection = loadable(() => import("./HeroSection/HeroSection"))
const Benefits = loadable(() => import("./Benefits/Benefits"))
const Disclaimer = loadable(() => import("./Disclaimer/Disclaimer"))
const FAQ = loadable(() => import("./FAQ/Faq"))


export { Header, Calculator, TalkToExpert, Image, MaterialModal, ExtraHeader, Disclaimer, HeroSection, QuickGuide, FAQ,Benefits };
